import React, { useState } from 'react'

function Timeline() {
    const [timelinecount,settimelinecount]=useState([4,5,9,6,4])
  return (
   <div className='flex w-full h-48 justify-center'>
     <div className='flex h-full overflow-hidden overflow-x-scroll hide-scroll-bar rounded-lg p-2 border' style={{backgroundColor:'#F1F5F9'}}>
        <div className='flex flex-col h-full mt-1'>
          <div className='flex flex-row w-full h-full items-center lg:justify-center '>
             {/* timeline skeleton */}
              {timelinecount.map((items)=>(
               <>
                   <div className='w-5 h-5 rounded-full bg-primary border-blue-500 border-4 cursor-pointer'></div>
                   <div className='w-40 bg-primary h-1 rounded-xl'></div>
               </>
              ))}
              <div className='w-5 h-5 rounded-full bg-primary border-blue-500 border-4'></div>
          </div>
    
         {/* time stopes */}
          <div className='flex flex-row w-full items-center mt-1 lg:justify-center'>
              {timelinecount.map((items)=>(
               <>
                   <div className='w-44 text-blue-500 cursor-pointer ms-1'>0.00 - 2.23</div>
                   {/* <div className='w-40 bg-slate-600 h-1 rounded-xl'></div> */}
               </>
              ))}
              <div className='w-5 h-5 '>End</div>
          </div>
         
         {/* description */}
          <div className='flex flex-row w-full items-center  mt-1 lg:justify-center'>
              {timelinecount.map((items)=>(
               <>
                   <div className='w-44 h-full ms-1 mb-1' style={{ color: '#606060' }}>Here Comes The Topic</div>
                   {/* <div className='w-40 bg-slate-600 h-1 rounded-xl'></div> */}
               </>
              ))}
              <div className='w-5 h-5' style={{visibility:'hidden'}}>End</div>
          </div>
    
    
        </div>
     </div>
   </div>
  )
}

export default Timeline